/**
 * Статусы участников
 */
export enum EParticipantsStatus {
  Enrolled = 'enrolled',
  Rejected = 'rejected',
  InTesting = 'in_testing',
  RejectedAtSurvey = 'rejected_at_survey',
  RejectedAtTest = 'rejected_at_test',
  AwaitingInvitation = 'awaiting_invitation',
  PendingAuthorization = 'pending_authorization',
  Accepted = 'accepted',
  Expelled = 'expelled',
}

export const PARTICIPANT_STATUS_TO_TAG_SETTINGS = {
  [EParticipantsStatus.Enrolled]: {
    text: 'Заявка подана',
    color: 'default',
  },
  [EParticipantsStatus.Rejected]: {
    text: 'Отклонён',
    color: 'volcano',
  },
  [EParticipantsStatus.InTesting]: {
    text: 'На тестировании',
    color: 'gold',
  },
  [EParticipantsStatus.RejectedAtSurvey]: {
    text: 'Отклонён по опросу',
    color: 'volcano',
  },
  [EParticipantsStatus.RejectedAtTest]: {
    text: 'Отклонён по тесту',
    color: 'volcano',
  },
  [EParticipantsStatus.AwaitingInvitation]: {
    text: 'Ожидает приглашения',
    color: 'gold',
  },
  [EParticipantsStatus.PendingAuthorization]: {
    text: 'Ожидает авторизации',
    color: 'gold',
  },
  [EParticipantsStatus.Accepted]: {
    text: 'Зачислен',
    color: 'green',
  },
  [EParticipantsStatus.Expelled]: {
    text: 'Отчислен',
    color: 'gray',
  },
};
